module.exports = __webpack_public_path__ + "static/media/street-bob-mobile.7ea9e6bf.png";